export default "__VITE_ASSET__06bfd361__"